import { Routes, Route } from "react-router-dom";
import PublicRoute from "./PublicRoute";
import LoginPage from "../pages/LoginPage";
import PrivateRoute from "./PrivateRoute";
import ProjectPage from "../pages/ProjectPage";
import FlightPage from "../pages/FlightPage";
import FlightAddPage from "../pages/FlightAddPage";
import SeePage from "../pages/SeePage";
import Layout from "../components/Layout";
import MaterialPage from "../pages/MaterialPage";
import MaterialAddPage from "../pages/MaterialAddPage";
import MaterialEditPage from "../pages/MaterialEditPage";
import ExportPage from "../pages/ExportPage";
import DesignPage from "../pages/DesignPage";
import DesignAddPage from "../pages/DesignAddPage";
import MeasurementPage from "../pages/MeasurementPage";
import MeasurementAddPage from "../pages/MeasurementAddPage";
import DrawToolContextProvider from "../utils/layers/draw/DrawToolContext";
import MeasurementEditPage from "../pages/MeasurementEditPage";
import SmartTrackingPage from "../pages/SmartTrackingPage";
import SmartTrackingAddPage from "../pages/SmartTrackingAddPage";
import SmartTrackingEditPage from "../pages/SmartTrackingEditPage";
import SignupPage from "../pages/SignupPage";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import ResetPasswordConfirmPage from "../pages/ResetPasswordConfirmPage";
import EmailVerifyPage from "../pages/EmailVerifyPage";
import DesignListPage from "../pages/DesignListPage";
import AccountPage from "../pages/Account";

import InvoicePage from "../pages/Account/InvoicePage";
import DownloadReportPage from "../pages/Report/DownloadReportPage";
import DisplayReport from "../pages/Report/DisplayReport";
import StockpileReportPage from "../pages/Report/StockpileReport";
import SupportPage from "../pages/Support/SupportPage";
import LineworkListPage from "../pages/LineworkListPage";
import LineworkCreatePage  from "../pages/LineworkCreatePage";



const RouteList = () => (
  <Routes>
    <Route element={<PublicRoute />}>
      <Route path="/" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/password-reset-confirm/:uid" element={<ResetPasswordConfirmPage />} />
      <Route path="/verify-email/:key" element={<EmailVerifyPage />} />
    </Route>

    <Route element={<PrivateRoute />}>
      <Route path="/displayReport" element={<DisplayReport />} />
      <Route path="/stockpileReport" element={<StockpileReportPage />} />

      <Route element={<Layout />}>
        <Route path="/project" element={<ProjectPage />} />
        <Route path="/flight" element={<FlightPage />} />
        <Route path="/flight/add" element={<FlightAddPage />} />
        <Route path="/see" element={<SeePage />} />
        <Route path="/material" element={<MaterialPage />} />
        <Route path="/material/add" element={<MaterialAddPage />} />
        <Route path="/material/edit" element={<MaterialEditPage />} />
        <Route path="/export" element={<ExportPage />} />
        <Route path="/design" element={<DesignListPage />} />
        <Route path="/design/add" element={<DesignAddPage />} />
        <Route path="/report" element={<DownloadReportPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/linework" element={<LineworkListPage />} />
        <Route path="/linework/add" element={<LineworkCreatePage />} />
        <Route path="/account/invoice" element={<InvoicePage />} />

        <Route
          path="/measure"
          element={
            <DrawToolContextProvider>
              <MeasurementPage />
            </DrawToolContextProvider>
          }
        />
        <Route
          path="/measure/add"
          element={
            <DrawToolContextProvider>
              <MeasurementAddPage />
            </DrawToolContextProvider>
          }
        />
        <Route
          path="/measure/edit"
          element={
            <DrawToolContextProvider>
              <MeasurementEditPage />
            </DrawToolContextProvider>
          }
        />
        <Route
          path="/smart-tracking"
          element={
            <DrawToolContextProvider>
              <SmartTrackingPage />
            </DrawToolContextProvider>
          }
        />
        <Route
          path="/smart-tracking/add"
          element={
            <DrawToolContextProvider>
              <SmartTrackingAddPage />
            </DrawToolContextProvider>
          }
        />
        <Route
          path="/smart-tracking/edit"
          element={
            <DrawToolContextProvider>
              <SmartTrackingEditPage />
            </DrawToolContextProvider>
          }
        />
      </Route>
    </Route>
  </Routes>
);

export default RouteList;
